import React from "react";

export default () => (
  <p className="mt-5 mb-3 text-muted text-center">
    &copy; <a href="https://eventlive.pro">eventlive.pro</a>
  </p>
);
